export const RUNNING = 'RUNNING';
export const STOPPED = 'STOPPED';
export const NAME = 'name';
export const HOST = 'host';
export const MOUNT = 'mount';
export const UNMOUNT = 'unmount';
export const ENTRYPOINTS = 'entrypoints';
export const DEFAULT_MANIFEST = 'asset-manifest.json';
export const FILE_EXTENSIONS = { CSS: '.css', JS: '.js' };
export const TEXT_CSS = 'text/css';
export const STYLESHEET = 'stylesheet';
export const DEVELOPMENT = 'development';
